
// Maps the field definition types to it's
export default {
    'Decimal': ()=> import("@/components/study/datafields/DecimalField.vue"),
    'LabValue': ()=> import("@/components/study/datafields/LabValueField.vue"),
    'MultiRangeLabValue': ()=> import("@/components/study/datafields/MultiRangeLabValueField.vue"),
    'Enumeration': ()=> import("@/components/study/datafields/EnumerationField.vue"),
    'CheckBox': ()=> import("@/components/study/datafields/CheckBoxField.vue"),
    'EventReportListEntry': ()=> import("@/components/study/datafields/EventReportListEntryField.vue"),
    'EventReportList': ()=> import("@/components/study/datafields/EventReportListField.vue"),
    'FieldGroup': ()=> import("@/components/study/datafields/FieldGroup.vue"),
    'Integer': ()=> import("@/components/study/datafields/IntegerField.vue"),
    'ListEntry': ()=> import("@/components/study/datafields/ListEntryField.vue"),
    'List': ()=> import("@/components/study/datafields/ListField.vue"),
    'MedicalDate': ()=> import("@/components/study/datafields/MedicalDateField.vue"),
    'Date': ()=> import("@/components/study/datafields/DateField.vue"),
    'Scale': ()=> import("@/components/study/datafields/ScaleField.vue"),
    'FreeText': ()=> import("@/components/study/datafields/TextField.vue"),
    'DisplayValue': () => import("@/components/study/datafields/DisplayValueField.vue"),
    'PatientPortalButton': ()=> import("@/components/study/datafields/PatientPortalButtonField.vue"),
    'SynQuestData': ()=> import("@/components/study/datafields/SynQuestDataField.vue"),
    'SignValue': ()=> import("@/components/study/datafields/SignValueField.vue"),
    'Autocomplete': ()=> import("@/components/study/datafields/AutocompleteField.vue"),
}
